import { CentroCostoLista } from "../CentroCostoLista/CentroCostoLista";
import { CentroCostoSelectOption } from "../CentroCostoSelectOption";

export class CentroCostoDisponibles {
  centrosCosto: CentroCostoLista[];

  constructor(data: any[]) {
    this.centrosCosto = data.map((v) => new CentroCostoLista(v));
  }

  get optionsList() {
    return this.centrosCosto.map((cc) => new CentroCostoSelectOption({cc, customText: `${cc.denominacion} (${cc.codigo}) / ${cc.numeroCuenta}`}));
  }
}